<template>
    <div class="page" v-if="washDetailVisible">
        <div class="comp-title">
            <span>信息录入</span>
            <el-button icon="el-icon-close" circle @click="close"></el-button>
        </div>
        <div class="content">
            <div class="table-info">
                <el-table
                    :data="washOrderitemList"
                    height="100%"
                    size="small"
                    :highlight-current-row="true"
                    border
                    style="width: 100%;margin-top: 0">
                    <el-table-column
                        prop="seq"
                        label="序号"
                        show-overflow-tooltip
                        align="center"
                        width="50">
                    </el-table-column>
                    <el-table-column
                        prop="barCode"
                        align="center"
                        show-overflow-tooltip
                        label="条码号">
                        <template scope="scope">
                            <span v-if="scope.row.barCode">{{ scope.row.barCode }}</span>
                            <span v-else>系统生成</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="productName"
                        align="center"
                        class="table-input"
                        show-overflow-tooltip
                        label="名称">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.productName" @focus="onFocus(scope.row, 'product')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="color"
                        align="center"
                        show-overflow-tooltip
                        label="颜色">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.color" @focus="onFocus(scope.row, 'color')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="flaw"
                        align="center"
                        show-overflow-tooltip
                        label="瑕疵">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.flaw" @focus="onFocus(scope.row, 'flaw')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        align="center"
                        show-overflow-tooltip
                        label="价格">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.price" @focus="onFocus(scope.row, 'price')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="remarks"
                        align="center"
                        show-overflow-tooltip
                        label="备注">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.remarks" @focus="onFocus(scope.row, 'brand')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="accessory"
                        align="center"
                        show-overflow-tooltip
                        label="配件">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.accessory" @focus="onFocus(scope.row, 'accessory')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="additionFee"
                        align="center"
                        show-overflow-tooltip
                        label="附加费">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.additionFee" @focus="onFocus(scope.row, 'additionFee')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="storageNumber"
                        align="center"
                        show-overflow-tooltip
                        label="存放号">
                        <template scope="scope">
                            <span v-if="scope.row.storageNumber && scope.row.storageName">{{scope.row.storageName}}{{scope.row.storageNumber}}</span>
                            <span v-else>系统生成</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="speed"
                        align="center"
                        show-overflow-tooltip
                        label="快慢">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.speed" @focus="onFocus(scope.row, 'speed')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="grade"
                        align="center"
                        show-overflow-tooltip
                        label="档次">
                        <template scope="scope">
                            <el-input size="small" v-model="scope.row.grade" @focus="onFocus(scope.row, 'grade')"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="pics"
                        align="center"
                        show-overflow-tooltip
                        label="照片">
                        <template scope="scope">
                            <!--                        <el-input size="small" v-model="scope.row.pics"></el-input>-->
                            <el-image
                                v-if="scope.row.pics"
                                style="width:60px; height: 43px"
                                :src="scope.row.pics.split('|')[0]"
                                :preview-src-list="scope.row.pics.split('|')">
                            </el-image>
                            <span v-if="!scope.row.pics">暂无照片</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="208"
                        show-overflow-tooltip
                        label="操作">
                        <template scope="scope">
                            <div class="btn-box">
                                <div @click="$refs.camera.show(scope.row.pics,scope.row.seq)">拍照</div>
                                <div @click="printShuiXiMaiTool(scope.row)">打印水洗唛</div>
                                <div style="background-color: #85ce61" @click="copy(scope.row)">复制</div>
                                <div v-if="scope.row.seq == washOrderitemList.length" @click="deleteItem()"
                                     style="background-color: #f56c6c">删除
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="fun-box">
                <el-button type="success" @click="saveItem">保存修改</el-button>
                <el-button v-if="order.orderStatus == 4" type="primary" @click="saveItem('done')">保存并完成录入</el-button>
            </div>

            <div class="bottom-box">
                <search-product v-if="showComponents == 'product'" @onProduct="onProduct"></search-product>
                <search-color v-if="showComponents == 'color'" @onColor="onColor"></search-color>
                <search-flaw v-if="showComponents == 'flaw'" @onFlaw="onFlaw" :flawString="washOrderitemObj.flaw"></search-flaw>
                <search-price ref="price" v-if="showComponents == 'price'" @onPrice="onPrice" :productId="washOrderitemObj.productId"></search-price>
                <search-brand v-if="showComponents == 'brand'" @onBrand="onBrand"></search-brand>
                <search-accessory v-if="showComponents == 'accessory'" @onAccessory="onAccessory"></search-accessory>
                <search-addition v-if="showComponents == 'additionFee'" @onAddition="onAddition"></search-addition>
                <search-speed v-if="showComponents == 'speed'" @onSpeed="onSpeed"></search-speed>
                <search-grade v-if="showComponents == 'grade'" @onGrade="onGrade"></search-grade>
            </div>

        </div>

        <camera ref="camera" @saveCamera="saveCamera"></camera>
    </div>
</template>

<script>
import Camera from '@/components/camera/camera.vue';
import SearchProduct from '@/components/wash/searchProduct.vue';
import SearchColor from '@/components/wash/searchColor.vue';
import SearchFlaw from '@/components/wash/searchFlaw.vue';
import SearchPrice from '@/components/wash/searchPrice.vue';
import SearchBrand from '@/components/wash/searchbrand.vue';
import SearchAccessory from '@/components/wash/searchAccessory.vue';
import SearchAddition from '@/components/wash/searchAddition.vue';
import SearchSpeed from '@/components/wash/searchSpeed.vue';
import SearchGrade from '@/components/wash/searchGrade.vue';
import { get, postJson, post } from '@/utils/request.js';

export default {
    components: {
        Camera,
        SearchProduct,
        SearchColor,
        SearchFlaw,
        SearchPrice,
        SearchBrand,
        SearchAccessory,
        SearchAddition,
        SearchSpeed,
        SearchGrade
    },
    data() {
        return {
            washDetailVisible: false,
            washOrderitemObj: null, // 当前引用数组中的一项数据对象
            washOrderitemList: [], // 该订单的每一双
            order: null, // 订单对象
            showComponents: 'product',
        };
    },
    methods: {
        // 打开窗口
        show(item) {
            this.getWashOrderitem(item);
            this.washDetailVisible = true;
            this.order = item;
            this.showComponents = 'product'
            this.washOrderitemObj = null
        },

        // 关闭窗口
        close() {
            this.washDetailVisible = false;
            this.washOrderitemList = []
            this.order = null
            this.showComponents = 'product'
            this.washOrderitemObj = null
        },

        // 复制项
        copy(washOrderItem){
            let newWashOrderItem = JSON.parse(JSON.stringify(washOrderItem))
            newWashOrderItem.seq = this.washOrderitemList.length + 1
            newWashOrderItem.barCode = `${this.order.receiveCode}-${newWashOrderItem.seq}`
            newWashOrderItem.pics = null
            newWashOrderItem.id = null
            this.washOrderitemList.push(newWashOrderItem)
        },

        // 获取该订单数据
        getWashOrderitem(item) {
            get('/wash/orderitem/findAll', {
                orderId: item.id
            }).then((res) => {
                if (res.success) {
                    this.washOrderitemList = [];
                    if (res.list.length > 0) {
                        this.washOrderitemList = res.list;
                    } else {
                        for (let i = 0; i < this.order.orderSize; i++) {
                            this.addItem();
                        }
                    }
                }
            });
        },

        // 添加操作
        addItem() {
            this.washOrderitemList.push({
                productId: null,
                productName: null,
                measureUnit: null,
                color: null,
                flaw: null,
                price: null,
                remarks: null,
                accessory: null,
                additionFee: null,
                speed: null,
                grade: null,
                pics: null,
                seq: this.washOrderitemList.length + 1,
                barCode: `${this.order.receiveCode}-${this.washOrderitemList.length + 1}`,
                orderId: this.order.id,
            });
        },

        // 删除操作
        deleteItem() {
            this.washOrderitemList.pop();
        },

        // 保存修改
        saveItem(flag) {
            for (const item of this.washOrderitemList) {
                console.log("item",item)
                if(!item.pics){
                    return this.$message.error('缺少照片信息')
                }
            }

            postJson('/wash/orderitem/saveBatch', { list: this.washOrderitemList }).then((res) => {
                if (res.success) {
                    this.getWashOrderitem(this.order);
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000,
                    });

                    if(flag == 'done'){
                        this.deliverGoods1(this.order);
                    }

                } else {
                    this.$message.error(res.msg)
                }
            });
        },

        // 下一个状态
        deliverGoods1(item){
            let ChangeStatus = {
                id: item.id,
                currentStatus: item.orderStatus,
                newStatus: item.orderStatus + 1
            }
            post(`/restaurant/order/changeOrderStatus`, ChangeStatus).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                    this.close();
                    this.$emit("updateData")
                }else{
                    this.$message.error(res.msg)
                }
            });
        },

        // 保存照片
        saveCamera(picString,seq){
            for (let i = 0; i < this.washOrderitemList.length; i++) {
                if(this.washOrderitemList[i].seq === seq){
                    this.washOrderitemList[i].pics = picString
                }
            }
        },

        // 获取焦点
        onFocus(obj,id){
            this.washOrderitemObj = obj
            this.showComponents = id

            this.$nextTick(()=>{
                if(id === 'price' && this.$refs.price){
                    this.$refs.price.getWashServicePriceList();
                }
            })
        },

        // 打印水洗唛工具
        printShuiXiMaiTool(washOrderItem){
            if (!window.chrome.webview) {
                this.$message({
                    message: "请在桌面软件内使用",
                    type: 'error',
                    duration: 2000
                });
            }

            // 单位为双时打印俩次
            if(washOrderItem.measureUnit == 2){
                this.printShuiXiMai(washOrderItem);
                this.printShuiXiMai(washOrderItem);
            } else {
                this.printShuiXiMai(washOrderItem);
            }
        },

        // 打印水洗唛
        printShuiXiMai(washOrderItem){
            if(washOrderItem.storageNumber == null){
                return this.$message.warning("请先保存信息")
            }

            let ordercocde = this.order.receiveCode;
            let seq = washOrderItem.seq;
            let total = this.washOrderitemList.length;
            let storeNmae = this.order.store.storeName;
            let storageArea = "Z";
            let storageNumber = washOrderItem.storageNumber;
            let userinfo = `客户:${this.order.user.userNickname}:${this.order.user.userMobile.replace(/(\d{3})\d{4}(\d{4})/, '\$1****\$2')}`;
            let product = `物件:${washOrderItem.productName ? washOrderItem.productName+washOrderItem.color : '无'}`;
            let addition = `[配件:${washOrderItem.accessory ? washOrderItem.accessory : '无'}]`;
            let flaw = `[瑕疵:${washOrderItem.flaw ? washOrderItem.flaw : '无'}]`;
            window.chrome.webview.postMessage(`printShuiximai(${ordercocde},${seq},${total},${storeNmae},${storageArea},${storageNumber},${userinfo},${product},${addition},${flaw})`);
            console.log(`printShuiximai(${ordercocde},${seq},${total},${storeNmae},${storageArea},${storageNumber},${userinfo},${product},${addition},${flaw})`)
        },

        // 点击了商品
        onProduct(productItem){
            console.log("选中的商品",productItem.measureUnit)
            // 当前无数据对象的的情况下直接创建一条，并把washOrderitemObj指向list中新增的数据对象
            if(this.washOrderitemObj == null){
                return
                // this.washOrderitemList.push({
                //     productId: productItem.id,
                //     productName: productItem.productName,
                //     color: null,
                //     flaw: null,
                //     price: null,
                //     remarks: null,
                //     accessory: null,
                //     additionFee: null,
                //     speed: null,
                //     grade: null,
                //     pics: null,
                //     seq: this.washOrderitemList.length + 1,
                //     barCode: `${this.order.receiveCode}-${this.washOrderitemList.length + 1}`,
                //     orderId: this.order.id,
                // });
                // this.washOrderitemObj = this.washOrderitemList[this.washOrderitemList.length - 1]
                //
                // // 选择商品后自动切换下一项
                // this.showComponents = 'color'
            } else {
                this.washOrderitemObj.productId = productItem.id
                this.washOrderitemObj.productName = productItem.productName
                this.washOrderitemObj.measureUnit = productItem.measureUnit
                this.washOrderitemObj.price = null

                // 自动跳转到下一项
                if(this.washOrderitemObj.color == null){
                    this.showComponents = "color"
                }
            }
        },

        // 点击了颜色
        onColor(colorItem){
            this.washOrderitemObj.color = colorItem.colorName

            if(this.washOrderitemObj.flaw == null){
                this.showComponents = "flaw"
            }
        },

        // 点击了瑕疵
        onFlaw(flawItem){
            let names = this.washOrderitemObj.flaw ? this.washOrderitemObj.flaw.split("|") : []

            for (let item of names) {
                if(item == flawItem.flawName){
                    names = names.filter(item => item !== flawItem.flawName);
                    return this.washOrderitemObj.flaw = names.join("|")
                }
            }

            names.push(flawItem.flawName)
            return  this.washOrderitemObj.flaw = names.join("|")
        },

        // 点击了价格
        onPrice(priceItem){
            this.washOrderitemObj.price = priceItem.servicePrice
        },

        // 点击了品牌
        onBrand(brandItem){
            this.washOrderitemObj.remarks = brandItem.brandName
        },

        // 点击了配件
        onAccessory(accessoryItem){
            this.washOrderitemObj.accessory = accessoryItem.accessoryName
        },

        // 点击了附加费
        onAddition(additionItem){
            this.washOrderitemObj.additionFee = additionItem.additionName
        },

        // 点击了速度
        onSpeed(speedItem){
            this.washOrderitemObj.speed = speedItem.speedName
        },

        // 点击了档次
        onGrade(gradeItem){
            this.washOrderitemObj.grade = gradeItem.gradeName
        }
    }
};

</script>

<style scoped lang="scss">
.page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background-color: #ccc;

    .comp-title {
        width: 100%;
        height: 60px;
        padding: 10px;
        border-bottom: 1px solid #ccc;
        background-color: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .content {
        padding: 5px;

        .fun-box {
            width: 100%;
            height: 80px;
            padding: 0 10px;
            margin-top: 2px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: right;

            .address{
                position: relative;
                flex: 1;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }

        .bottom-box{
            margin-top: 2px;
            padding: 10px;
            width: 100%;
            height: 410px;
            background-color: #fff;
        }
    }
}

.btn-box {
    display: flex;
    align-items: center;

    div {
        background-color: #409eff;
        border-radius: 3px;
        cursor: pointer;
        padding: 0 5px;
        margin: 2px;
        color: #fff;
    }
}

.table-info{
    height: calc(100vh - 60px - 80px - 410px - 14px);
}
</style>